// extracted by mini-css-extract-plugin
export var card = "_61-0";
export var expandedCard = "_61-2";
export var paginated = "_61-1";